import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { EventEmitter } from "events";
import { DialogData } from "src/app/entities/dialogData";
import { RevenueCode } from "src/app/entities/revenueCode";
import { CategoryService } from "src/app/services/category.service";
import { DropdownService } from "src/app/services/dropdown.service";
import { RevenueCodeService } from "src/app/services/revenueCode.service";
import { SharedService } from "src/app/services/sharedService";
import { MultiselectAutocompleteComponent } from "../../multiselect-autocomplete/multiselect-autocomplete.component";
import { DialogCommunicator } from "../dialog-communicator";
import { PropertyTaxService } from "src/app/services/propertyTax.service";

@Component({
  selector: 'app-property-tax-dialog',
  templateUrl: './property-tax-dialog.component.html',
  styleUrls: ['./property-tax-dialog.component.css']
})
export class PropertyTaxDialogComponent extends DialogCommunicator
  implements OnInit
{
  buildingId_
  buildingId
  selectedBuildingDetails
  bbox
  locationLatLng
  text: string;
  emitter: EventEmitter;
  revenueCode = {};
  propForm
  ccData = {}
  @ViewChild("revenueCodeSelect", { static: false })
  revenueCodeSelect: MultiselectAutocompleteComponent;
  selectedRevenue = [];
  filterData = {
    revenueCode: null,
  };
  constructor(
    public dialogRef: MatDialogRef<PropertyTaxDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public sharedService: SharedService,
    public categoryService: CategoryService,
    public propertyTaxService: PropertyTaxService,
    public confirmationDialog: MatDialog,

    public dropdownService: DropdownService
  ) {
    super(dialogRef, sharedService);
    this.setConfirmationDialog(this.confirmationDialog);
  }

  async ngOnInit() {
    this.propForm = await this.propertyTaxService.getForm('propTaxForm').toPromise()
    this.ccData = {
      key: this.propForm.key,
      name: this.propForm.name,
      stages: [this.propForm]
    }

  }
  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }
  setBBox(val){
    if (localStorage.getItem('municipalityBbox'))
    this.bbox = localStorage.getItem('municipalityBbox')
  }
}

